import React from 'react';
import {apiV2CryptoWalletsList} from "../../../../../api/merchant/cryptoWallet";
import walletsTableCtor from "./utils/walletsTableCtor";
import {paramStore} from "../../../../../stores";
import withState from "../../../../../utils/withState";
import Ripple from "../../../../dumb/Ripple";
import upperFirst from "mn-utils/upperFirst";

const request = (is_enabled) => (params = {}) => (
  apiV2CryptoWalletsList({...params, is_enabled})
)

const tabsItems = {
  active: walletsTableCtor(request(true)),
  inactive: walletsTableCtor(request(false)),
}

const tabsHeader = Object.keys(tabsItems);

const activeTab$ = paramStore('wallets', tabsHeader[0])

module.exports = withState(() => {
  return (state, props) => {

    const ActiveTab = tabsItems[state.activeTab];

    return (
      <div>
        <div className="layoutRow mt35 mh-8 (ph8)>1">
          {tabsHeader.map((key) => (
            <div key={key}>
              <Ripple
                className={`layoutRow fhaC fvaC h45 wmin76 ph10 bs b1 bcA f12 fw4 lh lts0em
                  tdN olN bc0:not[.disabled]:not[.checked]:h r9 dn
                  (bg|bc)A3A7AC.disabled.checked o50.disabled:not[.checked]
                  (cF|(bg|bc)5B47FF|bg4B37EF:not[.disabled]:h!).checked `
                  + (state.activeTab === key ? 'checked ' : '')
                }
                onClick={() => {
                  activeTab$.emit(key);
                  paramStore('s').emit('');
                }}
              >
                {upperFirst(key)}
              </Ripple>
            </div>
          ))}
        </div>
        {ActiveTab && <ActiveTab {...props} />}
      </div>
    )
  }
}, {
  activeTab: activeTab$
})
